// =============================================================================
// FAZA 1 SOFT STARTU — samoobsługowa sprzedaż ukryta dla klientów Receptora
//
// Klienci Receptora (plan 47 §4.4) wchodzą do Universe na planie `free` przez
// operatora albo partnera. Marketplace i Billing to SAMOOBSŁUGA, która ruszy
// w fazie 2; w fazie 1 kolejne organy sprzedaje opiekun ofertą. Pozycje menu
// i trasy znikają więc dla organizacji oznaczonej znacznikiem fazy.
//
// TO NIE JEST BRAMKA DOSTĘPU. Znacznik (`organizations.settings.sciezka`)
// steruje wyłącznie widocznością menu — o tym, czy organ wolno uruchomić,
// rozstrzyga baza (`modules.minimalny_plan` + strażnik na
// `module_subscriptions`, migracja 754). Administrator klienta, który
// znacznik usunie, zobaczy Marketplace i Billing — i nic nie uruchomi bez
// planu. Dlatego znacznik może mieszkać w niestrzeżonym `settings`.
//
// Po przejściu na plan płatny menu wraca samo (warunek planu niżej), a
// super-admin widzi wszystko zawsze.
// =============================================================================

/** Wartość `organizations.settings.sciezka` nadawana przez funkcję masową fazy 1. */
export const SCIEZKA_FAZY_1 = 'receptor_faza1';

interface OrganizacjaZUstawieniami {
  subscription_plan?: string | null;
  settings?: Record<string, unknown> | null;
}

interface UzytkownikZRola {
  is_super_admin?: boolean | null;
}

/** Czy ukryć Marketplace i Billing (samoobsługową sprzedaż) dla tej organizacji. */
export function ukryjSprzedazSamoobslugowa(
  organizacja: OrganizacjaZUstawieniami | null | undefined,
  uzytkownik: UzytkownikZRola | null | undefined
): boolean {
  if (uzytkownik?.is_super_admin) return false;
  if (!organizacja) return false;
  return (
    organizacja.settings?.sciezka === SCIEZKA_FAZY_1 && organizacja.subscription_plan === 'free'
  );
}

/** Trasy samoobsługowej sprzedaży — wspólne dla menu i strażnika tras. */
export const TRASY_SPRZEDAZY_SAMOOBSLUGOWEJ = [
  '/admin/modules',
  '/admin/marketplace',
  '/admin/billing',
] as const;
